export default class Errors {
    /**
     * Create a new Errors instance.
     */
    constructor() {
        this.errors = {};
    }


    /**
     * Determine if an errors exists for the given field.
     *
     * @param {string} field
     */
    has(field) {
        return this.errors.hasOwnProperty(field);
    }

    /**
     * Determine if an errors exists for the given field and returns
     * a 'error' string to be used as a classname.
     *
     * @param {string|Array} value
     */
    class(value) {
        if (value instanceof Array) {
            for (let index = 0; index < value.length; index++) {
                const field = value[index];

                if (this.errors.hasOwnProperty(field)) {
                    return 'has-errors';
                }
            }

            return '';
        }

        return this.errors.hasOwnProperty(value) ? 'has-errors' : '';
    }


    /**
     * Determine if we have any errors.
     */
    any() {
        return Object.keys(this.errors).length > 0;
    }


    /**
     * Retrieve the error message for a field.
     *
     * @param {string} field
     */
    get(field) {
        if (this.errors[field]) {
            if (typeof this.errors[field] === 'string') {
                return this.errors[field];
            }
            return this.errors[field][0];
        }
    }


    /**
     * Record the new errors.
     *
     * @param {object} errors
     */
    record(errors) {
        this.errors = errors;
    }


    /**
     * Clear one or all error fields.
     *
     * @param {string|null} field
     */
    clear(field) {
        if (field) {
            delete this.errors[field];

            return;
        }

        this.errors = {};
    }

    scrollToFirst() {
        if (!window.zenscroll) {
            console.log('Errors.scrollToFirst: You need Zenscroll to use this functionality.');
            return;
        }

        const firstError = document.querySelector('.form__input-holder-error');

        if (firstError) {
            zenscroll.center(firstError);
        }
    }
}